import React, { useEffect, useMemo } from 'react';

import { useLocation, useNavigate, useParams } from 'react-router-dom';

import Tab, { TabGroup as TabGroupLib } from '@amzn/meridian/tab';
import { AdminConfigPaths } from 'src/store/adminConfigPageSlice/common/constants';
import {
  fetchRegions,
  resetSeletedRegion,
  setSearchField,
  setSelectedRegion,
} from 'src/store/adminConfigPageSlice/regionTasksPageSlice/regionTasksPageSlice';
import { useAppDispatch, useAppSelector } from 'src/store/store';

// **** Components **** //

/**
 * Toggle the Task/TaskGroup Tables
 */
const RestrictionFormConfigurationTabGroup = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const { selectedRegion, regionTableData } = useAppSelector((state) => state.regionTasksConfigPage);
  const { userLoading } = useAppSelector((state) => state.user);
  const { Form: FormPaths } = AdminConfigPaths;
  const urlRegionId = Number(params.regionId);

  // Select a new tab by changing the path. Note that if we can see both the
  // tabs, then there should be a selectedRegion.id
  const navTab = (path: string) => {
    if (path === FormPaths.EDIT) {
      path = path + '/' + selectedRegion.id;
    }
    navigate(path, { replace: true });
  };

  // If at the root path, default to the Form Table
  useEffect(() => {
    if (location.pathname === FormPaths.root) {
      navTab(FormPaths.TABLE);
    }
  }, [location.pathname]);

  // Call fetchTableData() when user is loaded
  useEffect(() => {
    if (userLoading === 'fulfilled') {
      dispatch(fetchRegions());
    }
    return () => {
      dispatch(setSearchField(''));
      dispatch(resetSeletedRegion());
    };
  }, [userLoading]);

  // Set the selected region when the URL updates
  useEffect(() => {
    if (urlRegionId && regionTableData.length > 0 && location.pathname.startsWith(FormPaths.EDIT)) {
      const row = regionTableData.find((row) => row.id === urlRegionId);
      dispatch(setSelectedRegion(row));
    }
  }, [urlRegionId, regionTableData]);

  // Trim the region id from the edit path
  const tabGroupPathValue = useMemo(() => {
    if (location.pathname.startsWith(FormPaths.EDIT)) {
      return FormPaths.EDIT;
    } else {
      return location.pathname;
    }
  }, [location.pathname]);

  return (
    <TabGroupLib value={tabGroupPathValue} onChange={navTab}>
      <Tab value={FormPaths.TABLE}>Forms</Tab>
      {selectedRegion.id > 0 && <Tab value={FormPaths.EDIT}>{selectedRegion.name} Edit</Tab>}
    </TabGroupLib>
  );
};

// **** Export **** //

export default RestrictionFormConfigurationTabGroup;
